import { useState, useCallback } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
//

// ----------------------------------------------------------------------

export default function FullScreenOption() {
  const [fullscreen, setFullscreen] = useState(false);

  const onToggleFullScreen = useCallback(() => {
    const docEl = document.documentElement;
    const isInFullScreen = !!document.fullscreenElement;

    // Feature detection
    const canRequestFullscreen =
      docEl.requestFullscreen ||
      docEl.webkitRequestFullscreen || // Safari
      docEl.msRequestFullscreen || // IE11
      docEl.mozRequestFullScreen; // Firefox

    const exitFullscreen =
      document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.msExitFullscreen ||
      document.mozCancelFullScreen;

    try {
      if (!isInFullScreen) {
        if (canRequestFullscreen) {
          (canRequestFullscreen.call(docEl) || Promise.resolve()).then(() => {
            setFullscreen(true);
          });
        } else {
          console.warn('Fullscreen not supported on this device.');
        }
      } else {
        if (exitFullscreen) {
          exitFullscreen.call(document).then(() => {
            setFullscreen(false);
          });
        }
      }
    } catch (err) {
      console.error('Error toggling fullscreen:', err);
    }
  }, []);

  return (
    <Box sx={{ p: 2.5 }}>
      <ButtonBase
        onClick={onToggleFullScreen}
        sx={{
          width: 1,
          height: 48,
          borderRadius: 1,
          color: 'text.disabled',
          typography: 'subtitle2',
          border: theme => `solid 1px ${alpha(theme.palette.grey[900], 0.3)}`,
          ...(fullscreen && {
            color: 'text.primary',
          }),
          '& .svg-color': {
            background: theme =>
              `linear-gradient(135deg, ${theme.palette.grey[900]} 0%, ${theme.palette.grey[900]} 100%)`,
            ...(fullscreen && {
              background: theme =>
                `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
            }),
          },
        }}
      >
        {/* <SvgColor
          src={`/assets/icons/setting/${fullscreen ? 'ic_exit_full_screen' : 'ic_full_screen'}.svg`}
          sx={{ width: 16, height: 16, mr: 1 }}
        /> */}

        {fullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
      </ButtonBase>
    </Box>
  );
}
